<template>
  <div v-if="visible" class="toeper">
    <div class="last-toep">
      <span>{{ message }}</span>
    </div>
    <div class="loader-container">
      <div
        class="loader-bar"
        :style="{
          width: loaderWidth + '%',
          backgroundColor: loaderValue < 5 ? 'red' : 'green',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountdownTimer',
  props: {
    visible: Boolean,
    message: String,
    loaderWidth: Number,
    loaderValue: Number,
  },
}
</script>

